<template>
  <v-container
    fluid
    fill-height
    style="height:calc(100vh - 64px)"
  >
    <v-row style="height:100%; width:100%">
      <!-- Mapa -->
      <v-col
        cols="12"
        md="6"
        style="height: inherit"
      >
        <v-card height="100%">
          <v-row
            style="height: 100%"
            no-gutters
          >
            <v-col class="pa-1">
              <div style="height:100%;width:100%">
                <StatisticsMap :stats="statsFeatures" />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Statystyki -->
      <v-col
        cols="12"
        md="6"
        style="height: 100%"
      >
        <v-card
          ref="content"
          height="100%"
          id="stats-card"
        >
          <v-row
            ref="title"
            no-gutters
          >
            <v-col
              class="pa-3 d-flex justify-space-between align-center"
              cols="12"
            >
              <span class="headline">{{ $i18n.t('statistics.table.title') }}</span>
            </v-col>
          </v-row>
          <v-row
            ref="filters"
            class="pr-3 pl-5"
          >
            <v-col>
              {{$i18n.t('statistics.dateStart') + ': '}}
              <date-picker
                v-model="dateStart"
                value-type="timestamp"
                @change="updateDates()"
              ></date-picker>
            </v-col>
            <v-col>
              {{$i18n.t('statistics.dateEnd') + ': '}}
              <date-picker
                v-model="dateEnd"
                value-type="timestamp"
                @change="updateDates()"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row
            ref="table"
            no-gutters
            class="overflow-y-auto"
          >
            <template v-if="tableLoading">
              <v-col cols="12">
                <v-row
                  no-gutters
                  justify="center"
                  align="center"
                  style="height: 100%"
                >
                  <v-col cols="auto">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </template>
            <template v-else>
              <v-col
                cols="12"
                style="height: 100%;"
              >
                <CustomDataTable
                  entity-type="statistics"
                  maxHeight="100%"
                  :disablePagination="true"
                  :hasTools="false"
                  :headers="statsHeaders"
                  :items="offersStats"
                  @rowDetails="rowDetails"
                />
              </v-col>
            </template>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <DefaultDialog
      :dialog="isStatisticsDetailsVisible"
      @cancel="isStatisticsDetailsVisible = false;"
      max-width="30%"
    >
      <template v-slot:header>{{$i18n.t('statistics.details')}}</template>
      <template v-slot:content>
        <template v-if="detailsLoading">
          <v-col cols="12">
            <v-row
              no-gutters
              justify="center"
              align="center"
              style="height: 100%"
            >
              <v-col cols="auto">
                <v-progress-circular
                  indeterminate
                  color="primary"
                />
              </v-col>
            </v-row>
          </v-col>
        </template>
        <template v-else>
          <CustomDataTable
            entity-type="statistics"
            maxHeight="100%"
            :disablePagination="true"
            :hasTools="false"
            :headers="statsDetailsHeaders"
            :items="statsDetails"
          />
        </template>
      </template>
    </DefaultDialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import Attribute from '@/components/dashboard/Attribute';
import CustomDataTable from '@/components/CustomDataTable';
import DatePicker from 'vue2-datepicker';
import DefaultDialog from '@/components/DefaultDialog';
import StatisticsMap from '@/components/statistics/StatisticsMap';
import 'vue2-datepicker/index.css';

export default {
  name: 'Statistics',
  components: {
    CustomDataTable,
    DatePicker,
    DefaultDialog,
    StatisticsMap
  },
  data: () => ({
    dateStart: undefined,
    dateEnd: undefined,
    detailsLoading: true,
    isStatisticsDetailsVisible: false,
    offers: [],
    offersStats: [],
    projects: [],
    statsHeaders: [
      {
        text: 'offer_title',
        value: 'offer_title',
        type: 'text',
        translate: true
      },
      {
        text: 'project_title',
        value: 'project_title',
        type: 'text',
        translate: true
      },
      {
        text: 'click',
        value: 'event_count_per_type.click',
        type: 'number'
      }
    ],
    statsDetailsHeaders: [
      {
        text: 'event_time',
        value: 'event_time',
        type: 'date'
      }
    ],
    statsDetails: [],
    statsFeatures: [],
    tableLoading: true
  }),
  methods: {
    rowDetails(item) {
      this.openDetails(item.project_id, item.offer_id);
    },
    getOffersProjectsGeometry() {
      for (let idx in this.offersStats) {
        const offer_id = this.offersStats[idx].offer_id;
        this.offersStats[idx].geometry = this.offers.find(
          offer => offer.id === offer_id
        ).geometria;
      }
      this.statsFeatures = this.offersStats;
    },
    getStats() {
      this.offersStats = [];
      const payload = {};
      this.dateEnd ? (payload.end_date = this.dateEnd / 1000) : false;
      this.dateStart ? (payload.start_date = this.dateStart / 1000) : false;
      return axios({
        method: 'get',
        url: '/projects/stats',
        params: payload
      })
        .then(r => {
          if (r.status === 200) {
            const stats = r.data.stats;
            for (let stat of stats) {
              if (
                stat.offer_id &&
                stat.project_id &&
                stat.event_count_per_type.click
              ) {
                this.offersStats.push(stat);
              }
            }
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    getStatsDetails(payload) {
      return axios({
        method: 'get',
        url: '/projects/stats/details',
        params: payload
      }).then(r => {
        if (r.status === 200) {
          this.statsDetails = r.data.stats;
        }
      });
    },
    getOffers() {
      return axios({
        method: 'get',
        url: '/offers',
        params: { geometry: true }
      })
        .then(r => {
          if (r.status === 200) {
            this.offers = r.data.offers;
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    openDetails(project_id, offer_id) {
      this.statsDetails = [];
      this.detailsLoading = true;
      const payload = {};
      payload.project_id = project_id;
      payload.offer_id = offer_id;
      this.dateEnd ? (payload.end_date = this.dateEnd / 1000) : false;
      this.dateStart ? (payload.start_date = this.dateStart / 1000) : false;
      this.isStatisticsDetailsVisible = true;
      Promise.all([this.getStatsDetails(payload)]).then(() => {
        this.detailsLoading = false;
      });
    },
    updateDates() {
      this.tableLoading = true;
      if (this.dateStart && this.dateEnd && this.dateStart > this.dateEnd) {
        this.dateEnd = [this.dateStart, (this.dateStart = this.dateEnd)][0];
      }
      Promise.all([this.getStats()]).then(() => {
        this.getOffersProjectsGeometry();
        this.tableLoading = false;
      });
    }
  },
  mounted() {
    Promise.all([this.getStats(), this.getOffers()]).then(() => {
      this.getOffersProjectsGeometry();
      this.tableLoading = false;
    });
  }
};
</script>
<style lang="scss">
html {
  overflow: hidden;
}
div.v-data-table__wrapper.vb-content {
  height: inherit !important;
}
#stats-card {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 55px 100px auto;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
#table-stats {
  height: 100%;
}
.table__row--background {
  background-color: rgba($primary-color, 0.2) !important;
}
</style>